<div class="filter-item-dialog-component dialog-component">
  <div class="dialog-title">
    <div class="title-row">
      <div class="icon-container">
        @if (audienceFilter.filterConfig && audienceFilter.filterConfig.iconUrl) {
          <img [src]="audienceFilter.filterConfig.iconUrl" class="app-image" />
        }
        @if (audienceFilter.filterConfig && audienceFilter.filterConfig.icon) {
          <mat-icon class="filter-icon">{{ audienceFilter.filterConfig.icon }}</mat-icon>
        }
      </div>
      <div class="text-container">
        <span class="filter-label">{{ "audience.settings.filter" | translate }}:&nbsp;</span>
        @if (audienceFilter) {
          <span>{{ audienceFilter.filterConfig?.titleKey | translate }}</span>
        }
        @if (audienceFilter.filterConfig.isNew) {
          <span class="new-addon" style="margin: 0 10px 0; padding: 2px 5px">NEW</span>
        }
      </div>
    </div>
  </div>
  @if (audienceFilter.type === AudienceFilterTypes.Purchase) {
    <div class="note">
      <span [innerHTML]="'audience.note-sending-data' | translate"></span>
    </div>
  }
  @if (loadingOptions) {
    <div class="dialog-content">
      <mat-spinner [diameter]="48" [mode]="'indeterminate'"></mat-spinner>
    </div>
  }

  @if (!loadingOptions) {
    <div class="dialog-content">
      <div [ngClass]="isTypeGoalOrPurchase ? 'goal-filter-first-row' : ''">
        <div class="text-and-operator">
          @if (filterInputType === FilterInputTypes.Weather || filterInputType === FilterInputTypes.Temperature) {
            <div class="note-container">
              <app-note-info [note]="partialNote" [fillSpace]="true"></app-note-info>
            </div>
          }
          <div class="filter-description-text">
            <span class="description">
              {{ audienceFilter.filterConfig?.descriptionKey ? ("audience.filter-config." + audienceFilter.filterConfig?.descriptionKey | translate) : "" }}
            </span>
            @if (showOperator) {
              <div class="operator-box new-style-custom-input" [matMenuTriggerFor]="operatorsDropdown">
                <span class="operator-text">
                  {{ "audience.operators." + (filterOperator | audienceFilterOperator: audienceFilter.filterConfig) | translate }}
                </span>
                <mat-icon>arrow_drop_down</mat-icon>
              </div>
              <mat-menu #operatorsDropdown="matMenu" class="operators-dropdown-menu">
                <div fxLayout="column" fxLayout.xs="column">
                  @for (operator of audienceFilter.filterConfig?.supportedOperators; track operator) {
                    <div>
                      <button mat-menu-item (click)="filterOperatorUpdated(operator)">
                        <span>{{ "audience.operators." + (operator | audienceFilterOperator: audienceFilter.filterConfig) | translate }}</span>
                      </button>
                    </div>
                  }
                </div>
              </mat-menu>
            }
            @if (audienceFilter.filterConfig?.descriptionKeyAfter) {
              <span class="description-after">
                {{ "audience.filter-config." + audienceFilter.filterConfig?.descriptionKeyAfter | translate }}
              </span>
            }
          </div>
        </div>
        @if (filterInputType === FilterInputTypes.BooleanDropdown) {
          <mat-form-field class="boolean-dropdown-value" appearance="outline" [class.invalid]="audienceValueError">
            <mat-select [(value)]="filterValueString" required>
              <mat-option [disabled]="audienceFilter.disabledOption?.toLowerCase() === 'yes'" [value]="'true'">{{ "generic.yes" | translate }}</mat-option>
              <mat-option [disabled]="audienceFilter.disabledOption?.toLowerCase() === 'no'" [value]="'false'">{{ "generic.no" | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
          @if (audienceValueError) {
            <mat-hint class="invalid">{{ "generic.required" | translate }}</mat-hint>
          }
        }
        @if (filterInputType === FilterInputTypes.TextField) {
          <mat-form-field class="text-field-value" appearance="outline" [class.invalid]="audienceValueError">
            <input matInput type="text" [(ngModel)]="filterValueString" required />
          </mat-form-field>
          @if (audienceValueError) {
            <mat-hint class="invalid">{{ "generic.required" | translate }}</mat-hint>
          }
        }
        @if (filterInputType === FilterInputTypes.Number) {
          <mat-form-field class="text-field-value" appearance="outline" [class.invalid]="audienceValueError">
            <input matInput type="number" min="1" max="10" [(ngModel)]="filterValueString" required />
          </mat-form-field>
          @if (audienceValueError) {
            <mat-hint class="invalid">{{ "generic.required" | translate }}</mat-hint>
          }
        }
        @if (filterInputType === FilterInputTypes.SingleChoiceDropdown) {
          @if (audienceFilter.type !== AudienceFilterTypes.Purchase) {
            <mat-form-field class="single-choice-dropdown-value new-style-input" appearance="outline" [class.invalid]="audienceValueError">
              <mat-select [(value)]="filterValueString" (selectionChange)="loadTagsOptions()" required placeholder="{{ 'generic.choose' | translate }}">
                @for (valueOption of choosableValueOptions; track valueOption) {
                  <mat-option [value]="valueOption.key">
                    <span id="value-text" [innerHTML]="valueOption.value | translate"></span>
                  </mat-option>
                }
              </mat-select>
              @if (audienceValueError) {
                <mat-hint class="invalid">{{ "generic.required" | translate }}</mat-hint>
              }
              @if (!audienceValueError && audienceFilter.type === AudienceFilterTypes.AppSegment && audienceFilter.app === AudienceFilterApp.Rule) {
                <mat-hint class="segments-rule-info" [innerHTML]="'campaign.widget.audience.rule-segment.info' | translate"></mat-hint>
              }
            </mat-form-field>
          }
          @if (audienceFilter.type === AudienceFilterTypes.Purchase) {
            <mat-form-field class="single-choice-dropdown-value new-style-input" appearance="outline" [class.invalid]="audienceValueError">
              <input matInput type="text" [(ngModel)]="filterValueString" required readonly />
            </mat-form-field>
          }
          @if (isAppTags) {
            @if (!choosableValueTagOptions?.length && filterValueString) {
              <div>{{ "audience.filter-config.filter-list-have-no-tags" | translate }}</div>
            }
            @if (choosableValueTagOptions?.length) {
              <div>{{ "audience.filter-config." + $safeNavigationMigration(audienceFilter.filterConfig?.subDescriptionKey) | translate }}:</div>
              <mat-form-field class="single-choice-dropdown-value" appearance="outline" [class.invalid]="audienceValueError">
                <mat-select
                  [(value)]="filterValueTagString"
                  (selectionChange)="audienceValueError = false"
                  required
                  placeholder="{{ 'generic.choose' | translate }}">
                  @for (valueOption of choosableValueTagOptions; track valueOption) {
                    <mat-option [value]="valueOption.key">
                      <span [innerHTML]="valueOption.value | translate"></span>
                    </mat-option>
                  }
                </mat-select>
                @if (audienceValueError) {
                  <mat-hint class="invalid">{{ "generic.required" | translate }}</mat-hint>
                }
              </mat-form-field>
            }
          }
        }
        @if (filterInputType === FilterInputTypes.MultiChoiceDropdown) {
          @if (isCountryFilter) {
            <app-country-select [value]="filterValueArray" (valueChange)="filterValueArray = $event" [required]="true"></app-country-select>
            @if (audienceValueError) {
              <mat-hint class="invalid">{{ "generic.required" | translate }}</mat-hint>
            }
          } @else {
            <mat-form-field class="multiple-choice-dropdown-value new-style-input" appearance="outline" [class.invalid]="audienceValueError">
              <mat-select [(value)]="filterValueArray" multiple required>
                @for (valueOption of choosableValueOptions; track valueOption) {
                  <mat-option [value]="valueOption.key">
                    <span [innerHTML]="valueOption.value"></span>
                  </mat-option>
                }
              </mat-select>
              @if (audienceValueError) {
                <mat-hint class="invalid">{{ "generic.required" | translate }}</mat-hint>
              }
            </mat-form-field>
          }
        }
      </div>
      @if (filterInputType === FilterInputTypes.Weather || filterInputType === FilterInputTypes.Temperature) {
        <div class="weather-filter">
          <!-- First for Weather Type -->
          <div class="weather-section">
            <h3>{{ "audience.filter-config.visitor-in-weather" | translate }}:</h3>
            <mat-button-toggle-group
              class="weather-buttons"
              name="weather"
              hideSingleSelectionIndicator="true"
              [(value)]="audienceFilter.weatherProperties.weatherType"
              required
              (change)="onWeatherChange($event)">
              @for (weatherType of weatherTypeOptions; track weatherType) {
                <mat-button-toggle [value]="weatherType">
                  <img [src]="'/assets/img/icons/weather/' + weatherType.toLowerCase() + '.svg'" alt="" />
                  <span>{{ "audience.filter-config.weatherType-" + weatherType.toLowerCase() | translate }}</span>
                </mat-button-toggle>
              }
            </mat-button-toggle-group>
          </div>
          <!-- Section for location -->
          <div class="location-section">
            <h3>
              <mat-icon>explore</mat-icon>
              {{ "audience.filter-config.weatherLocation-title" | translate }}:
            </h3>
            <div class="location-row">
              <div>
                <span>{{ "audience.filter-config.longitude" | translate }}</span>
                <mat-form-field class="location-field small-input-field" appearance="outline" required>
                  <input matInput type="number" [(ngModel)]="audienceFilter.weatherProperties.customLongitude" required />
                </mat-form-field>
              </div>
              <div>
                <span>{{ "audience.filter-config.latitude" | translate }}</span>
                <mat-form-field class="location-field small-input-field" appearance="outline" required>
                  <input matInput type="number" [(ngModel)]="audienceFilter.weatherProperties.customLatitude" required />
                </mat-form-field>
              </div>
            </div>
          </div>
          <!-- Section for Temperature -->
          <div class="temperature-section">
            <h3>
              <mat-icon>thermostat</mat-icon>
              {{ "audience.filter-config.weatherTemperature-title" | translate }}:
            </h3>
            <div class="temperature-row">
              <div>
                <span>{{ "audience.filter-config.weatherTemperature-before" | translate }}</span>
                <mat-form-field class="temperature-field small-input-field" appearance="outline" required>
                  <input matInput type="number" [(ngModel)]="audienceFilter.weatherProperties.minTemperature" required />
                </mat-form-field>
                <span>{{ "audience.filter-config.weatherTemperature-between" | translate }}</span>
              </div>
              <div>
                <mat-form-field class="temperature-field small-input-field" appearance="outline" required>
                  <input matInput type="number" [(ngModel)]="audienceFilter.weatherProperties.maxTemperature" required />
                </mat-form-field>
                <span>{{ "audience.filter-config.weatherTemperature-after" | translate }}</span>
              </div>
            </div>
            @if (isTemperatureRangeInvalid) {
              <mat-hint class="error">
                <span>{{ "audience.filter-config.weatherTemperature-rangeError" | translate }}</span>
              </mat-hint>
            }
          </div>
          <!-- Section for Wind -->
          <div class="wind-section">
            <h3>
              <mat-icon>storm</mat-icon>
              {{ "audience.filter-config.weatherWind-title" | translate }}:
            </h3>
            <div class="wind-row">
              <div>
                <span>{{ "audience.filter-config.weatherTemperature-before" | translate }}</span>
                <mat-form-field class="wind-field small-input-field" appearance="outline" required>
                  <input matInput type="number" [(ngModel)]="audienceFilter.weatherProperties.minWindspeed" required min="0" />
                </mat-form-field>
                <span>{{ "audience.filter-config.weatherTemperature-between" | translate }}</span>
              </div>
              <div>
                <mat-form-field class="wind-field small-input-field" appearance="outline" required>
                  <input matInput type="number" [(ngModel)]="audienceFilter.weatherProperties.maxWindspeed" required min="0" />
                </mat-form-field>
                <span>{{ "audience.filter-config.weatherWind-after" | translate }}</span>
              </div>
            </div>
            @if (isWindRangeInvalid) {
              <mat-hint class="error">
                <span>{{ "audience.filter-config.weatherWind-rangeError" | translate }}</span>
              </mat-hint>
            }
          </div>
          <!-- Second for Time Frame -->
          <h3 class="when-text">{{ "dashboard.leads.when" | translate }}:</h3>
          <mat-radio-group
            aria-labelledby="timeframe-radio-group-label"
            class="timeframe-radio-group"
            [(value)]="timeFrame"
            (change)="onTimeFrameChange($event.value)">
            <mat-radio-button value="now">{{ "audience.filter-config.weather-choice-now" | translate }}</mat-radio-button>
            <mat-radio-button value="checkToday">{{ "audience.filter-config.weather-today" | translate }}</mat-radio-button>
            <mat-radio-button value="checkTomorrow">{{ "audience.filter-config.weather-tomorrow" | translate }}</mat-radio-button>
            <mat-radio-button value="daysForward">{{ "audience.filter-config.weather-days-forward" | translate }}</mat-radio-button>
            <mat-radio-button value="specificDay">{{ "audience.filter-config.weather-specific-date" | translate }}</mat-radio-button>
            <mat-radio-button value="checkNextWeekend">{{ "audience.filter-config.weather-next-weekend" | translate }}</mat-radio-button>
            <mat-radio-button value="inDays">{{ "audience.filter-config.weather-in-days" | translate }}</mat-radio-button>
          </mat-radio-group>
          <!-- Conditional Input for X Days Forward -->
          @if (timeFrame === "daysForward") {
            <mat-form-field class="text-field-value" appearance="outline" [class.invalid]="audienceValueError">
              <input matInput type="number" min="1" max="10" [(ngModel)]="audienceFilter.weatherProperties.daysForward" required />
              <mat-error class="invalid">{{ "audience.timeframe.invalid-days-10" | translate }}</mat-error>
            </mat-form-field>
          }
          <!-- Conditional Input for In Days -->
          @if (timeFrame === "inDays") {
            <mat-form-field class="text-field-value" appearance="outline" [class.invalid]="audienceValueError">
              <input matInput type="number" min="1" max="10" [(ngModel)]="audienceFilter.weatherProperties.inDays" required />
              <mat-error class="invalid">{{ "audience.timeframe.invalid-days-10" | translate }}</mat-error>
            </mat-form-field>
          }
          <!-- Conditional Datepicker for Specific Day -->
          @if (timeFrame === "specificDay") {
            <mat-form-field class="text-field-value" appearance="outline" required>
              <input matInput [matDatepicker]="picker" [(ngModel)]="audienceFilter.weatherProperties.specificDay" required />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error class="invalid">{{ "generic.required" | translate }}</mat-error>
            </mat-form-field>
          }
          <!-- Description Text -->
          <p class="weather-more-help" [innerHTML]="'audience.filter-config.weather-more-help' | translate"></p>
        </div>
      }
      @if (isTypeGoalOrPurchase) {
        @if (isTypePurchaseOperatorEquals || isTypeGoalOperatorEquals) {
          <div class="goal-filter-second-row">
            <!-- Frequency -->
            <app-frequency-selector
              [frequencyOperator]="frequencyOperator"
              [frequencyValue]="frequencyValue"
              [frequencyValueError]="frequencyValueError"
              (frequencyOperatorUpdated)="filterFrequencyOperatorUpdated($event)"></app-frequency-selector>
          </div>
        }
        <div [ngClass]="isFrequencyHidden ? 'goal-filter-second-row' : 'goal-filter-third-row'">
          <!--Time-frame -->
          <app-timeframe-selector
            [timeframeOperator]="timeframeOperator"
            [timeframeValueError]="timeframeValueError"
            [daysFC]="daysFC"
            [startDateFC]="startDateFC"
            [endDateFC]="endDateFC"
            [daysStartFC]="daysStartFC"
            [daysEndFC]="daysEndFC"
            (timeframeOperatorChanged)="filterTimeframeOperatorUpdated($event)"></app-timeframe-selector>
        </div>
        <!--Sales -->
        @if (isTypePurchaseOperatorEquals) {
          <div class="goal-filter-forth-row">
            <div class="sales">
              <ng-container>
                <div class="custom-field">
                  <div class="label">{{ "audience.purchase" | translate }}</div>
                  <div class="sales-row">
                    <div
                      class="operator-box new-style-custom-input"
                      [ngClass]="salesOperator"
                      [matMenuTriggerFor]="salesOperator !== AudienceFilterSalesOperator.Any ? salesOperatorsDropdown : salesDropdown">
                      <span class="operator-text">{{ "audience.salesOperators." + salesOperator | translate }}</span>
                      &nbsp;
                      @if (salesOperator !== AudienceFilterSalesOperator.Any) {
                        <ng-container>{{ sumStartFC.value }}</ng-container>
                        @if (account) {
                          &nbsp;{{ account.currency | uppercase }}
                        }
                        @if (salesOperator === AudienceFilterSalesOperator.Between) {
                          <span>&nbsp;{{ "generic.and" | translate }}&nbsp;</span>
                          {{ sumEndFC.value }}
                          @if (account) {
                            {{ account.currency | uppercase }}
                          }
                        }
                      }
                      <mat-icon>arrow_drop_down</mat-icon>
                    </div>
                    <mat-menu #salesOperatorsDropdown="matMenu" class="sales-menu">
                      <div class="operator-box" [ngClass]="salesOperator" [matMenuTriggerFor]="salesDropdown" (click)="openSubMenu($event)">
                        <span class="operator-text">{{ "audience.salesOperators." + salesOperator | translate }}</span>
                        <mat-icon>arrow_drop_down</mat-icon>
                      </div>
                      <div (click)="openSubMenu($event)" class="sales-menu-content">
                        @if (salesOperator !== AudienceFilterSalesOperator.Any) {
                          <mat-form-field class="new-style-input number-input-field" appearance="outline" [class.invalid]="salesValueError">
                            <input matInput type="number" [formControl]="sumStartFC" [min]="0" required />
                          </mat-form-field>
                          @if (account) {
                            <div class="label">&nbsp;&nbsp;{{ account.currency | uppercase }}</div>
                          }
                        }
                        @if (salesOperator === AudienceFilterSalesOperator.Between) {
                          &nbsp;&nbsp;
                          <mat-form-field class="new-style-input number-input-field" appearance="outline" [class.invalid]="salesValueError">
                            <input matInput type="number" [formControl]="sumEndFC" [min]="1" required />
                          </mat-form-field>
                          @if (account) {
                            <div class="label">&nbsp;&nbsp;{{ account.currency | uppercase }}</div>
                          }
                        }
                      </div>
                    </mat-menu>
                    <mat-menu #salesDropdown="matMenu" class="operators-dropdown-menu">
                      <div>
                        @for (salesOperator of SalesOperators; track salesOperator) {
                          <div>
                            <button mat-menu-item (click)="closeSubMenuSales($event, salesOperator)">
                              <span>{{ "audience.salesOperators." + salesOperator | translate }}</span>
                            </button>
                          </div>
                        }
                      </div>
                    </mat-menu>
                  </div>
                </div>
                @if (salesValueError) {
                  <div class="sales-validation-row">{{ salesValueError | translate }}</div>
                }
              </ng-container>
            </div>
            <mat-slide-toggle [(ngModel)]="hasAppliedCoupon"></mat-slide-toggle>
            <span>{{ "audience.applied-coupon" | translate }}</span>
          </div>
        }
      }
      @if (audienceFilter.filterConfig?.descriptionKey2) {
        <div [innerHTML]="'audience.filter-config.' + audienceFilter.filterConfig?.descriptionKey2 | translate"></div>
      }
    </div>
  }
  <div class="actions-row">
    <button mat-stroked-button class="secondary-button cancel-button" (click)="closeDialog()">{{ "generic.cancel" | translate }}</button>
    <button mat-stroked-button class="primary-button save-button" (click)="saveFilterItem()" [disabled]="getDisabledSubmit">
      {{ "generic.save" | translate }}
    </button>
  </div>
</div>
